import React from "react";
import PropTypes from "prop-types";
import { SCREENS } from "common/constants/Constants";
import styles from "./styles.module.scss";

function getHelpUrl(bloombergSiteUrl, pathname) {
    if (pathname.includes(SCREENS.COUNTER_OFFER)) {
        return `${ bloombergSiteUrl }/help/question/introductory-offers`;
    }

    return `${ bloombergSiteUrl }/notices/help`;
}

const BloombergBanner = ({ bloombergSiteUrl, pathname }) => {
    const helpUrl = getHelpUrl(bloombergSiteUrl, pathname);

    return (
        <header className={ styles.banner }>
            <span className={ styles.bloomberg }><a className={ styles.homeLink } href={ bloombergSiteUrl }>Bloomberg</a></span>
            <span className={ styles.help }><a className={ styles.helpLink } href={ helpUrl } target="_blank">Need help?</a></span>
        </header>
    );
};

BloombergBanner.propTypes = {
    bloombergSiteUrl: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired
};

export default BloombergBanner;
